import _ from '/home/ps/root'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import ioApp from './io/'
import { io } from 'socket.io-client'
const { act, dispatch, go, tcp, tact } = ioApp
// import { ParkProvider } from './context'
import MasterViews from './component/master/views'
import configureStore, { history } from './store/configureStore'
import { Ref, uuid12, goOffline, cookies, cache, Route, Param } from './global'
import action from './action'

const { QID, DOMAIN, DEV_NAMESPACE, SIO_NAMESPACE, DEV_PATH, SIO_PATH } = _
const __DEV__ = import.meta.env.__DEV__
// const NAMESPACE = __DEV__ ? DEV_NAMESPACE : SIO_NAMESPACE
const NAMESPACE = SIO_NAMESPACE
// const PATH = __DEV__ ? DEV_PATH : SIO_PATH
const PATH = SIO_PATH
window.ps = {}
const route = Route()
let cookie = cookies()
const __dev_user__ = () => {
  const policy = ';path=/;SameSite=Strict'
  // const policy = ';path=/;Domain=.paksof.com;SameSite=Lax'
  // const policy = ';path=/;SameSite=Lax'
  // const policy = ';path=/;SameSite=None;Secure'
  document.cookie = `p=s10${ policy }`
  // cookie.p = 's10'
  const vendorname = route[0]
  const vid = cache(vendorname)
  const row = cache(vid)
  const login = cookie.login
  const pk = row?.id || QID + 1
  const id = login ? pk : -pk
  document.cookie = `id=${ id }${ policy }`
  // cookie.id = id
  const init = uuid12()
  document.cookie = `init=${ init }${ policy }`
  // cookie.init = init
  const username = row?.username || 'master'
  document.cookie = `username=${ username }${ policy }`
  // cookie.username = username
  if (login) {
    const login = Math.floor(Date.now() / 1000)
    document.cookie = `login=${ login }${ policy }`
    // cookie.login = login
    if (row) {
      document.cookie = `name=${ row.name }${ policy }`
      // cookie.name = row.name
      document.cookie = `home=${ row.home }${ policy }`
      // cookie.home = row.home
    }
  }
}
if (__DEV__) __dev_user__()
cookie = cookies()
// const URL = __DEV__ ?
//   `${ window.location.origin }${ NAMESPACE }` :
//   `/${ cookie.p }.${ DOMAIN }${ NAMESPACE }`
// const URL = `${ __DEV__ ? 'http://' : ''}${ cookie.p }.${ DOMAIN }${ SIO_NAMESPACE }`
// const protocol = window.location.protocol
// const URL = `${ protocol }//${ cookie.p }.${ DOMAIN }${ SIO_NAMESPACE }`
if (!cookie.p) debugger
const URL = `${ cookie.p }.${ DOMAIN }${ SIO_NAMESPACE }`
const container = document.getElementById('view')
const root = createRoot(container)
const render = (Component, prop) => {
  // <ParkProvider initialStore={prop.store}>
  // </ParkProvider>
  root.render(
    <React.StrictMode>
      <Provider store = { prop.store }>
        <BrowserRouter future = { { v7_startTransition: true, v7_relativeSplatPath: true } }>
            <Component { ...prop } />
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  )
}
const config = {
  path: PATH,
  reconnection: false,
  autoConnect: false,
  withCredentials: true,
  transports: ['websocket', 'polling'],
}
Ref.socket = io(URL, config)
_.EVENT_.forEach(e => Ref.socket.on(e, dispatch))
Ref.history = history
const connect = (_connect) => {
  // act(action.connect(_connect))
  if (_connect) {
    if (!Ref.socket.connected) {
      // if (__DEV__) Ref.socket.connected = true
      // else
      Ref.socket.connect()
    }
  } else {
    if (Ref.socket.connected) {
      // if (__DEV__) delete(Ref.socket.connected)
      // else
      Ref.socket.disconnect()
    }
  }
  console.log(`ROOT.connect`, { _connect, connected: Ref.socket.connected, socket: Ref.socket }, cookies())
}
const mount = store => {
  const props = {
    store: Ref.store,
    history: Ref.history,
    mount,
    connect,
    action,
    // cookie,
    io: ioApp,
  }
  console.log(`ROOT.mount`, { URL, cookie, config, props, connected: Ref.socket.connected })
  render(MasterViews, props)
}
Ref.socket.on('disconnect', (reason) => {
  act(action.connect(Ref.socket.connected))
  console.log(`Root.disconnect ${ reason }`, Ref.socket.connected)
})
Ref.socket.on('connect', () => {
  act(action.connect(Ref.socket.connected))
  console.log(`Root.connect ${ Ref.socket.id }`, Ref.socket.connected)
})
Ref.store = configureStore()
mount(Ref.store)
window.addEventListener("beforeunload", (e) => {
  Ref.socket.disconnect()
  console.log('beforeunload - disconnecting socket')
  return "Losing Queue";
})
